<template>
  <div>
    <div v-if="!loading">
      <div class="text-gray-600 mb-4" v-if="!error">
        <p class="text-gray-400 mb-1">server: {{emailSettings.server}} : {{emailSettings.port}}</p>
        <p class="text-gray-400 mb-1">user: {{emailSettings.user}} / hasPass: {{emailSettings.hasPass}}</p>
        <p class="text-gray-400 mb-1">mailFrom: {{emailSettings.mailFrom}}</p>
        <p class="text-gray-400 mb-1">auth: {{emailSettings.auth}}</p>
        <p class="text-gray-400 mb-1">starttls: {{emailSettings.starttls}}</p>
        <p class="text-gray-400 mb-1">debug: {{emailSettings.debug}}</p>
        <!--{{ emailSettings }}-->
      </div>
      <div class="text-red-600" v-else>
        Ошибка
      </div>
    </div>
    <LoaderIcon v-else/>

    <button @click.prevent="openModal" class="px-4 py-2 mt-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors cursor-pointer">
      Проверить отправку
    </button>
    <ModalWindow :show="checkModal.show" @close="closeModal" @done="doneModal" title="Проверить отправку">
      <form class="space-y-6" action="#" method="POST" @submit.prevent="submitForm(e)">
        <p class="text-gray-600 mb-1">То:</p>
        <div class="mb-2">
          <input name="to" v-model="formData.to" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"/>
        </div>

        <p class="text-gray-600 mb-1">subject:</p>
        <div class="mb-2">
          <input name="subject" v-model="formData.subject" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"/>
        </div>

        <p class="text-gray-600 mb-1">message:</p>
        <div class="mb-2">
          <textarea name="message" v-model="formData.message" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"></textarea>
        </div>

        <div v-if="sendError != null">
          {{sendError}}
        </div>
      </form>
    </ModalWindow>
  </div>
</template>

<script>
import LoaderIcon from "@/components/LoaderIcon.vue";
import ModalWindow from "@/components/modal/ModalWindow.vue";

export default {
  name: 'EmailServiceSettingsBlock',
  components: {ModalWindow, LoaderIcon},
  data() {
    return {
      emailSettings: null,
      error: null,
      sendError: null,
      loading: true,
      formData: {
        to: null,
        subject: null,
        message: null
      },
      checkModal: {
        title: "Проверка отправки",
        message: "Введите параметры отправки",
        show: false,
        showDone: false,
        showCancel: false,
      }
    }
  },
  mounted() {
    this.loadData();
  },
  computed: {
    /*tokenExist: function () {
      return this.emailSettings?.id > 0;
    }*/
  },
  methods: {
    closeModal: function () {
      this.checkModal.show = false;
    },
    doneModal: function () {
      console.log("doneModal")
      this.checkSendEmail();
    },
    openModal: function () {
      console.log("openModal")
      this.checkModal.show = true;
    },
    submitForm: function () {
      console.log(">> submitForm")
    },
    checkSendEmail: function () {
      console.log(">> checkSendEmail", this.formData)
      let c = this;
      if (c.loading) {
        return;
      }
      c.sendError = null;
      c.loading = true;
      this.axios.post('/api/admin/email/check-send', this.formData).then(function(response) {
        c.loading = false;
        console.log("email check-send", response.data);
      }).catch(function(err) {
        c.loading = false;
        c.sendError = err.data();
        console.log(err.status);
      });
    },
    loadData: function () {
      console.log("load email service settings");
      let c = this;
      c.emailSettings = null;
      c.loading = true;
      c.error = false;
      this.axios.get('/api/admin/email/settings').then(function(response) {
        console.log(response.data);
        c.emailSettings = response.data.data;
        c.loading = false;
      }).catch(function(err) {
        console.log(err.status);
        c.loading = false;
        c.error = true;
      });
    }
  }
}
</script>

<style scoped>

</style>